import React from "react";
import "./Legal.css";

/**
 * Kopfzeile mit Navigation. Die Logo‑Platzhalter kann von
 * Nutzerinnen und Nutzern durch ein eigenes Logo ersetzt werden.
 */
const Impressum = () => {
  return (
    <section className="legal-section">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Impressum</h1>
          <p className="legal-subtitle">Angaben gemäß § 5 TMG</p>
        </div>

        <div className="legal-content">
          <div className="legal-card">
            <h2>Kontaktinformationen</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Name:</span>
                <span className="info-value">Daniel Lanz</span>
              </div>
              <div className="info-item">
                <span className="info-label">Adresse:</span>
                <span className="info-value">
                  Vogelbeerweg 5
                  <br />
                  77656 Offenburg
                  <br />
                  Deutschland
                </span>
              </div>
            </div>
          </div>

          <div className="legal-card">
            <h2>Kontakt</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">E-Mail:</span>
                <a href="mailto:info@technik-lanz.de" className="info-link">
                  info@technik-lanz.de
                </a>
              </div>
              <div className="info-item">
                <span className="info-label">Telefon:</span>
                <a href="tel:+491742638614" className="info-link">
                  +49 174 263 8614
                </a>
              </div>
              <div className="info-item">
                <span className="info-label">Website:</span>
                <a href="https://technik-lanz.de" className="info-link">
                  www.technik-lanz.de
                </a>
              </div>
            </div>
          </div>

          <div className="legal-card">
            <h2>Verantwortlich für den Inhalt</h2>
            <p>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
              <br />
              <strong>Daniel Lanz</strong>
              <br />
              Musterstraße 123, 12345 Musterstadt
            </p>
          </div>

          <div className="legal-card">
            <h2>Haftungsausschluss</h2>

            <h3>Haftung für Inhalte</h3>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
              diese Inhalte umgehend entfernen.
            </p>

            <h3>Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>
            <p>
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
              mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
              Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
              inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
              konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
              Bekanntwerden von Rechtsverletzungen werden wir derartige Links
              umgehend entfernen.
            </p>

            <h3>Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            <p>
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht
              kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
              Seite nicht vom Betreiber erstellt wurden, werden die
              Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
              Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
              Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
              entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
              werden wir derartige Inhalte umgehend entfernen.
            </p>
          </div>

          <div className="legal-card">
            <h2>Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="info-link"
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </div>

          <div className="legal-footer">
            <p>
              Stand:{" "}
              {new Date().toLocaleDateString("de-DE", {
                year: "numeric",
                month: "long",
              })}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impressum;
